//new deploymentsgit add .
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

// Layout components
import Navbar from "./components/navbar";
import Footer from "./components/footer";

// Pages
import Home from "./pages/home";
import AboutUs from "./pages/aboutus";
import Features from "./pages/features";
import Services from "./pages/services";
import Blog from "./pages/blog";
import Contact from "./pages/contactus";
import Experts from "./pages/experts";
import Careers from "./pages/careers";
import Vacancies from "./pages/vacancies";
import Applicationform from "./pages/applicationform";
import Feedback from "./pages/Feedback";
import Client from "./pages/Client";

import usePageTracking from "./usePageTracking";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);

  return null;
};

const PageTracker = () => {
  usePageTracking();
  return null;
};

const App = () => {
  React.useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <PageTracker />

      <Navbar />

      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/features" element={<Features />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/experts" element={<Experts />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/vacancies" element={<Vacancies />} />
          <Route path="/applicationform" element={<Applicationform />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/client" element={<Client />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
};

export default App;